// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { alarmApi } from '../apis/alarm.api';

// action
import { actions } from '../actions/alarm.action';
import { ResultBaseProps } from 'modules/common';
import { ReqCreateEnvAlarm, ResAlarms, ResUnreadAlarmCount } from '../models/alarm.model';
import qs from 'qs';
import { RootState } from 'modules/rootReducer';

/**
 * 기상 알람 생성
 */
export const createEvnAlarm = createAsyncThunk<ResultBaseProps, ReqCreateEnvAlarm>(
  actions.CREATE_ENV_ALARM,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await alarmApi.createEnvAlarm(data);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 알람 리스트 조회
 */
export const getAlarms = createAsyncThunk<ResAlarms, string | undefined, { state: RootState }>(
  actions.GET_ALARMS,
  async (userId, { getState, fulfillWithValue, rejectWithValue }) => {
    try {
      if (!userId) {
        return rejectWithValue('error');
      }

      const request = getState().alarm.fetchAlarmRequest;
      const query = qs.stringify(request);
      const response = await alarmApi.fetchAlarms(userId, query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 읽지 않은 알람 카운트
 */
export const getUnreadAlarmCount = createAsyncThunk<ResUnreadAlarmCount, string>(
  actions.GET_UNREAD_ALARM_COUNT,
  async (id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await alarmApi.fetchUnreadAlarmCount(id);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 알람 읽음 처리
 */
export const postAlarmReaded = createAsyncThunk<ResultBaseProps, string>(
  actions.POST_ALARM_READED,
  async (id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await alarmApi.createAlarmReaded(id);

      return fulfillWithValue(response);
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
